// 设置闹钟——主流程
const MainRoutes = Array.from({ length: 8 }, (_, i) => ({
  path: `contacts/index${i + 1}`,
  name: `contactsIndex${i + 1}`,
  component: () => import(`@/views/use/contacts/index${i + 1}.vue`)
}))



export default {
  path: '/use',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 设置闹钟——主流程，开始
    ...MainRoutes,

  ],
};
